export default __webpack_public_path__ + "static/media/everglades.a6f62ae3.png";